window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

// slate.rte = {

//   wrapTable: function() {
//     $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
//   },

//   iframeReset: function() {
//     var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
//     var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

//     $iframeVideo.each(function() {
//       // Add wrapper to make video responsive
//       $(this).wrap('<div class="rte__video-wrapper"></div>');
//     });

//     $iframeReset.each(function() {
//       // Re-set the src attribute on each iframe after page load
//       // for Chrome's "incorrect iFrame content on 'back'" bug.
//       // https://code.google.com/p/chromium/issues/detail?id=395791
//       // Need to specifically target video and admin bar
//       this.src = this.src;
//     });
//   }
// };

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;
        var options = variant.options;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      // BEGIN SWATCHES
      var selector = this.originalSelectorId;
      if (variant) {
        var $headerOption = $('#headerOption');
        var radioButton = $(selector).closest('form').find(".swatch-element.color input[type='radio']:checked");
        if (radioButton.length) {
          radioButton.get(0).checked = true;
          if ($headerOption.length) {
            $headerOption.addClass('active').html(radioButton.get(0).value);
          }
          
          if( $('.color-filter-header .swatch-img').length && radioButton.data('img')  ){
            $('.color-filter-header .swatch-img').css({ "background-image": "url(" + radioButton.data('img') + ")" });
            if( $('.color-filter-header .swatch--tooltip img').length ){
            	$('.color-filter-header .swatch--tooltip img').attr('src', radioButton.data('img'));
            }
            
          }
        }
      }
      // END SWATCHES

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });

    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');
    
    this.settings = {};
    this.namespace = '.product';

    if ( this.$container.hasClass('product-quickview') && $('#productJson_' + sectionId).length ) {
      this.productJson = $('#productJson_' + sectionId).html();
      this.productSingleObject = JSON.parse(this.productJson);
      
      /*this.productJson = $('#productJson_' + sectionId).html();
      this.productSingleObject = JSON.parse(this.productJson);*/
    }
    else {
      if( $(selectors.productJson, this.$container).length ){
        this.productJson = $(selectors.productJson, this.$container).html();
        this.productSingleObject = JSON.parse(this.productJson);
      }
    }
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!this.productSingleObject) {
      return;
    }

    //this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));
    //slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
    this.initVariants();

    var waypoints = $('#productSidebar').waypoint({
      handler: function(direction) {
        if (direction === 'down') {
          $('#stickyMobileBar').removeClass('sticky');
        } else {
          $('#stickyMobileBar').addClass('sticky');
        }
      },
      offset: 'bottom-in-view'
    });

  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };
	  $(document).on('change', '.swatch :radio', function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

      this.customPropertyHandlers();
      if (this.$container.attr('id') === 'singleProduct') {
        this.initMobileCarousel(this.variants.currentVariant);
      }
    },

    customPropertyHandlers: function() {
      var $monogramFields = $('#productMonogram');
      if ($monogramFields.length) {
        var $monogramSelects = $('.monogram-select select'),
            $monogramInputs = $('.monogram-property'),
            $monogramCharacters = $('#monogramCharacters'),
            $monogramHeaderOption = $('#monogramHeaderOption'),
            $monogramFontOptions = $('#monogramFontOptions');

        // toggle visibility of Monogram fields
        if ($('.swatch-monogram :radio:checked').val() === 'Yes') {
          $monogramFields.removeClass('hide');
          $monogramInputs.prop("disabled",false);
          $('.swatch-sp').hide();
        }else{
        	$('.swatch-sp').show();
        }
        $('.swatch-monogram :radio').change(function() {
          if ($(this).val() === 'Yes') {
            $monogramFields.removeClass('hide');
            $monogramInputs.prop("disabled",false);
            $('.swatch-sp').hide();
          } else {
            $monogramFields.addClass('hide');
            $monogramInputs.prop("disabled",true);
            $('.swatch-sp').show();
          }
        });

        // populate line item property input from characer selects
        $monogramSelects.change(function(){
          if (!$monogramCharacters.prop('disabled')) {
            var monogramVal = '';
            $monogramSelects.each(function(i){
              monogramVal += $(this).val();
            });
          }
          $monogramCharacters.val(monogramVal);
        });

        // set header label for Embroidery Style
        var updateMonogramHeader = function() {
          var activeFontOption = $monogramFontOptions.find("input[type='radio']:checked");
          if (activeFontOption.length) {
            activeFontOption.get(0).checked = true;
            $monogramHeaderOption.addClass('active').html(activeFontOption.get(0).value);
          }
        }
        updateMonogramHeader();
        $monogramFontOptions.find("input[type='radio']").change(function(){
          updateMonogramHeader();
        });

      }
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabeled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      
      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html('Unavailable');
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $('#backorder').removeClass("hidden");
        if (variant.inventory_quantity > 0) {
          jQuery('#backorder span').addClass("hidden");
          jQuery('#backorder span[data-instock-id="'+variant.id+'"]').removeClass("hidden");
        } else {
          jQuery('#backorder span').addClass("hidden");
          jQuery('#backorder span[data-preorder-id="'+variant.id+'"]').removeClass("hidden");
        }

        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html('Add To Bag');
      } else {
        $('#backorder').addClass("hidden");
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html('Sold Out');
      }
    },

    initMobileCarousel: function(currentVariant) {
      var $productImages = $('#productImages');
      var $productThumbs = $('#productThumbs');
      if (currentVariant.featured_image !== null) {
        $productImages.on('init', function(event, slick){
          var variantSlide = $productImages.find('.slick-slide[data-id=' + currentVariant.featured_image.id + ']').data('index');
          setTimeout(function(){
            $productImages.slick('slickGoTo', variantSlide);
          }, 200);
        });
      }
      $productImages.slick();

      $productThumbs
        .on('init', function(event, slick) {
          $('.slider-nav .slick-slide.slick-current').addClass('is-active');
          $(this).removeClass('hidden');
        })
        .slick({
          slidesToShow: 4,
          slidesToScroll: 4
        });

      $productImages.on('afterChange', function(event, slick, currentSlide) {
        $productThumbs.slick('slickGoTo', currentSlide);
        var currrentNavSlideElem = $productThumbs.find('.slick-slide[data-slick-index="' + currentSlide + '"]');
        $productThumbs.find('.slick-slide').removeClass('slick-current');
        $(currrentNavSlideElem).addClass('slick-current');
      });

      $productThumbs.on('click', '.slick-slide', function(event) {
        event.preventDefault();
        var goToSingleSlide = $(this).data('slick-index');
        $productImages.slick('slickGoTo', goToSingleSlide);
      });

    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);



      if ( $comparePrice.hasClass('vn-discount') && $comparePrice.data('dvl') ) {
        var datadvl 			= parseFloat($comparePrice.data('dvl'));
      	var discount_val 		=  variant.price * datadvl;
      	var discounted_price 	=  variant.price - discount_val;
        $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(discounted_price, theme.moneyFormat));
        if (variant.compare_at_price > variant.price || variant.price > discounted_price ) {
          if(variant.compare_at_price){
            $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          }else{
            $comparePrice.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
          }
          $compareEls.removeClass('hide');
        } else {
          $comparePrice.html('');
          $compareEls.addClass('hide');
        }
      }else{
        $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));
        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          $compareEls.removeClass('hide');
        } else {
          $comparePrice.html('');
          $compareEls.addClass('hide');
        }
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      if( $('#productImages-ws').length ){
      	var $productImages = $('#productImages-ws');
        	$productImages.find('div').hide();
        	$productImages.find('div[data-id="' + variant.featured_image.id + '"]').fadeIn();
      }else if( $('#productImages').length ){
        var $productImages = $('#productImages');
            $goToSingleSlide = $productImages.find('.slick-slide[data-id="' + variant.featured_image.id + '"]'),
            goToIndex = $goToSingleSlide.data('slick-index');
        $productImages.slick('slickGoTo', goToIndex);
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


// *****************************************
// doc ready
// *****************************************
// hide page loader if it exists
if ($("#pageLoading").length) {
  $(window).on('load', function() {
    $("#pageLoading").fadeOut(200);
  });
}

$(document).ready(function() {

  // begin CART JS
  // --------------------------------------
  CartJS.init(theme.strings.cartJSON);

  // actions for the 'quick view' instances
  // $(document).on('cart.requestComplete', function(event, cart) {
  //   if ($('body').hasClass('template-collection')) {
  //   }
  // });

  // * copied from CartJS core
  var unwrapKeys = function(obj, type, override) {
    var key, unwrapped, unwrappedKey, value;
    if (type == null) {
      type = 'properties';
    }
    unwrapped = {};
    for (key in obj) {
      value = obj[key];
      unwrappedKey = key.replace("" + type + "[", "").replace("]", "");
      unwrapped[unwrappedKey] = override != null ? override : value;
    }
    return unwrapped;
  };
  $('form[action="/cart/add"]').on('submit', function(e){
    // * copied from CartJS core
    e.preventDefault();
    if ( $('#productMonogram').length && $('.swatch-monogram :radio:checked').val() === 'Yes') {
      	var $sel1 = 'a', $sel2 = 'a', $sel3 = 'a';
        if( $('#monogram-character-1').length ){
			$sel1 = $('#monogram-character-1').val();
        }
      	if( $('#monogram-character-2').length ){
			$sel2 = $('#monogram-character-2').val();
        }
      	if( $('#monogram-character-3').length ){
			$sel3 = $('#monogram-character-3').val();
        }
        if( !$sel1 && !$sel2 && !$sel3 ){
          	if( $('#monogramModal').length ) $('#monogramModal').modal("show");
        	return false;
        }
    }
    
    var $form = $(this);
    var dataArray, id, properties, quantity;
    dataArray = $form.serializeArray();
    id = void 0;
    quantity = void 0;
    properties = {};
    $.each(dataArray, function(i, item) {
      if (item.name === 'id') {
        return id = item.value;
      } else if (item.name === 'quantity') {
        return quantity = item.value;
      } else if (item.name.match(/^properties\[[\w ]+\]$/)) {
        return properties[item.name] = item.value;
      }
    });
    unwrappedProperties = unwrapKeys(properties);

    CartJS.addItem(id, quantity, unwrappedProperties, {
      "success": function(data, textStatus, jqXHR) {
        var $successMessage = $form.find('.item-added-success');
        $successMessage.removeClass('hide');
        setTimeout(function(){ $successMessage.addClass('hide') }, 3000);
        $('#cartTooltipToggle').trigger('click');
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
        var $errorMessage = $form.find('.item-added-error');
        $errorMessage.removeClass('hide').html(jqXHR.responseJSON.message + ': ' + jqXHR.responseJSON.description);
        setTimeout(function(){ $errorMessage.addClass('hide') }, 3000);
      }
    });
  });

  // open cart tooltip for click on button, but close for a click anywhere else
  $('#cartTooltipToggle').on('click', function(e) {
    $('#cartTooltip').addClass('in');
    e.stopPropagation();
  });
  $(document).on('click', function(e) {
    $('#cartTooltip').removeClass('in');
  });

  // end CART JS
  // --------------------------------------

  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  //slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });
  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  // Target tables to make them scrollable
  // var tableSelectors = '.rte table';

  // slate.rte.wrapTable({
  //   $tables: $(tableSelectors),
  //   tableWrapperClass: 'rte__table-wrapper',
  // });

  // Target iframes to make them responsive
  // var iframeSelectors =
  //   '.rte iframe[src*="youtube.com/embed"],' +
  //   '.rte iframe[src*="player.vimeo"]';

  // slate.rte.wrapIframe({
  //   $iframes: $(iframeSelectors),
  //   iframeWrapperClass: 'rte__video-wrapper'
  // });

  // Apply a specific class to the html element for browser support of cookies.
  // if (slate.cart.cookiesEnabled()) {
  //   document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  // }

  // video modal stop play on close
  $('.modal-video').on('show.bs.modal', function(){
    var $iframe = $(this).find('iframe');
    $iframe.attr('src', $iframe.data('src'));
  });
  $('.modal-video').on('hide.bs.modal', function(){
    var $iframe = $(this).find('iframe');
    $iframe.removeAttr('src');
  });

  $('.active-class-toggle').on('click', function(){
    var target = $(this).data('target'),
        $target = $(target);
    if ($target.hasClass('active')) {
      $target.removeClass('active');
    }
    else {
      $target.addClass('active');
    }
  });

  $('.class-toggle').on('click', function(){
    var target = $(this).data('target'),
        targetClass = $(this).data('target-class');
    $(target).toggleClass(targetClass);
  });

  $('.footer-links__nav-toggle').on('click', function(){
    var $parent = $(this).closest('.footer-links__col');
    if ($parent.hasClass('nav-active')) {
      $parent.removeClass('nav-active');
    }
    else {
      $parent.addClass('nav-active');
    }
  });

  // BOOTSTRAP PANELS INIT
  if ($('.panel-group').length > 0) {
    $(".panel").on("show.bs.collapse hide.bs.collapse", function(e) {
      if (e.type=='show'){
        $(this).addClass('panel-active');
      }else{
        $(this).removeClass('panel-active');
      }
    });
  }

  // EMPTY HASH LINKS
  $('a.prevent-default').click(function(evt){
    evt.preventDefault();
  });

  // SCROLL TO LINKS
  $('.scrollto').on('click', function(evt){
    evt.preventDefault();
    var target = $(this).attr('href');
    $('html, body').stop().animate({ scrollTop: ($(target).offset().top - 15) }, 300);
  });

  // 'SHOP THE POST' CAROUSELS
  if ($('body').hasClass('template-blog')) {
    $('.shopthepost-carousel').slick({
      lazyLoad: 'ondemand'
    });
  }
  if ($('body').hasClass('template-article')) {
    $('.shopthepost-carousel').slick({
      lazyLoad: 'ondemand',
      slidesToScroll: 1,
      slidesToShow: 3,
      rows: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
  
  if (typeof Spurit === 'undefined') {
    window.Spurit = {};
  }
  
//   Spurit.globalOnLoad = function(){
//     Spurit.global.atc.onBeforeEventPrevented((event, target) => {
//       if ( $('#productMonogram').length && $('.swatch-monogram :radio:checked').val() === 'Yes') {
//           var $sel1 = 'a', $sel2 = 'a', $sel3 = 'a';
//           if( $('#monogram-character-1').length ){
//               $sel1 = $('#monogram-character-1').val();
//           }
//           if( $('#monogram-character-2').length ){
//               $sel2 = $('#monogram-character-2').val();
//           }
//           if( $('#monogram-character-3').length ){
//               $sel3 = $('#monogram-character-3').val();
//           }
//           if( !$sel1 && !$sel2 && !$sel3 ){
//               if( $('#monogramModal').length ) $('#monogramModal').modal("show");
// 	            console.log('returning false');
//               return false;
//           }
//       }
//       return true;
      
//     });
//     Spurit.global.atc.onBefore((event, target, lineItems, submitMode, next) => {
	  
//       next(Spurit.global.constants.ATC.SUBMIT_MODE_AJAX, lineItems);
//     });
//     Spurit.global.atc.onAfter((event, target, lineItems, submitMode) => {
  
//       if(submitMode !== Spurit.global.constants.ATC.SUBMIT_MODE_AJAX){
//         return;
//       }
//       $('#cartTooltipToggle').trigger('click');

//     });
    
//   }
/*Fixing label on Safari*/
$('label').click(function() {});
  /*Menu drop-down*/
  	
    $('.navbar-primary .dropdown').mouseenter(function() {
      	$('.navbar-primary .dropdown').removeClass('dropdown-menu-active');
     	$(this).delay(100).queue(function() {
                           $(this).addClass('dropdown-menu-active');
                           $(this).dequeue();
                       });
      
    })
    .mouseleave(function() {
        $(this).delay(1).queue(function() {
                           $(this).removeClass('dropdown-menu-active');
                           $(this).dequeue();
                       });
    });
    $('.filter-swatches-title').on('click', function(e) {
        e.preventDefault();
        var $wrapper = $(this).parent();
        if ($wrapper.hasClass('active')) {
            $wrapper.removeClass('active');
            if( $wrapper.hasClass('order-swatches-wrapper') ){
				$('.swatch-filters .os-checkbox').fadeOut();
            }
        } else {
            $wrapper.addClass('active');
          	if( $wrapper.hasClass('order-swatches-wrapper') ){
				$('.swatch-filters .os-checkbox').fadeIn();
            }
        }

    });

    var $filterCheckboxes = $('.filter-wrapper .fl-element input[type="radio"]');
    $filterCheckboxes.on('change', function() {

        var selectedFilters = {};

        $filterCheckboxes.filter(':checked').each(function() {

            if (!selectedFilters.hasOwnProperty(this.name)) {
                selectedFilters[this.name] = [];
            }
            selectedFilters[this.name].push(this.value);
        });
        var $filteredResults = $(".swatch-filters .swatch-element");
        $.each(selectedFilters, function(name, filterValues) {

            $filteredResults = $filteredResults.filter(function() {

                var matched = false,
                    currentFilterValues = $(this).data('cat').split(' ');
                $.each(currentFilterValues, function(_, currentFilterValue) {
                    if ($.inArray(currentFilterValue, filterValues) != -1) {
                        matched = true;
                        return false;
                    }
                });
                return matched;

            });
        });
        $(".swatch-filters .swatch-element").hide().filter($filteredResults).show();
    });
    $('.swatch-filters .os-checkbox').on('change', function(){
      var $this = $(this);
      if( !$this.data('id') ){
        $('.f-swatches-wrapper').addClass('loading');
        jQuery.getJSON('/products/' + $this.val() + '.js', function(product) {
          if( product.available ){
          	$this.data('id', product.variants[0].id);
          }else{
          	$this.prop('disabled', true);
            $this.prop('checked', false);
            $('#os-ajax-msg').addClass('error').removeClass('success').text('We are sorry but this swatch is currently not available.').fadeIn().delay(1500).fadeOut();
          }
          
        }).fail(function() {
    		$this.prop('disabled', true);
            $this.prop('checked', false);
            $('#os-ajax-msg').addClass('error').removeClass('success').text('We are sorry but this swatch is currently not available.').fadeIn().delay(1500).fadeOut();
  		}).always(function() {
    		$('.f-swatches-wrapper').removeClass('loading');
              var qty = $('.swatch-filters .os-checkbox:checked').length;
              $('.order-swatches-wrapper .swatch-qty span').text( qty );
              if( qty  ){
                $('.order-swatches-wrapper button').prop('disabled', false);
              }else{
                $('.order-swatches-wrapper button').prop('disabled', true);
              }
  		});
      }else{
            var qty = $('.swatch-filters .os-checkbox:checked').length;
          $('.order-swatches-wrapper .swatch-qty span').text( qty );
          if( qty  ){
            $('.order-swatches-wrapper button').prop('disabled', false);
          }else{
            $('.order-swatches-wrapper button').prop('disabled', true);
          }
      }

    });
  	$('.order-swatches-wrapper button').on('click', function(e){
      
      e.preventDefault();
      var products = new Array();
      
      $('.swatch-filters .os-checkbox:checked').each(function(){
        var id = $(this).data('id');
        if( id ){
          	products.push({ id: id, quantity: 1 });
        }
      });
      if( products.length ) {
        $('.f-swatches-wrapper').addClass('loading');
        jQuery.post('/cart/add.js', {
            items: products
        }, function(){
          	CartJS.getCart();
          	$('#os-ajax-msg').addClass('success').removeClass('error').text('The selected swatches have been successfully added to your cart').fadeIn().delay(1500).fadeOut();
          	$('#cartTooltipToggle').trigger('click');
        }, 'json').fail(function() {
    		$('#os-ajax-msg').addClass('error').removeClass('success').text('There was an error while adding the swatches to the cart, please try again later.').fadeIn().delay(1500).fadeOut();
  		}).always(function() {
    		$('.f-swatches-wrapper').removeClass('loading');
  		});
      }
    });
  
  	if( $('.related-posts-wrapper').length ) {
      
      var p_num = $('.related-posts-wrapper').data('num'),
          p_current = $('.related-posts-wrapper').data('current'),
      	  rp_collections = ['rugs', 'pillows','wallpaper', 'furniture', 'lighting','art'],
          p_type 		= $('.related-posts-wrapper').data('type'),
          arr_index 	 = rp_collections.indexOf(p_type),
          pr_ajax=0,
          $rp_temp 		= $('.related-posts-wrapper .rp_temp');
          
      	  if (arr_index > -1) {
            rp_collections.splice(arr_index, 1);
            rp_collections.push(p_type);
          }
          $.each(rp_collections, function( index, value ) {
            loadJSONcollection( value, p_current, 1, function(data) {
              pr_ajax++;
              $rp_temp.append( data );
            });
          });
          loadJSONcollection( 'cross-sale-products', p_current, 2,function(data) {
            $rp_temp.append( data );
            pr_ajax = pr_ajax+2; 
          });
      	$( document ).ajaxComplete(function() {
          if( pr_ajax == p_num && $('.related-posts-wrapper .rp_temp').length ){
            var data =  $rp_temp.html();
            $rp_temp.remove();
            $('.related-posts-wrapper').html( data ).removeClass('loading').slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
              });
          }
        });
        
    }

});

function loadJSONcollection( collection, p_current, p_num = 1, callback ) {
  var product_html = '';
  $.ajax({
    url:	"/collections/" + collection + "?view=json",
    type:	'GET'
  })
  .done(function(data) {
    var products = $.parseJSON(data);
    for(var i = products.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * i);
      var temp = products[i];
      products[i] = products[j];
      products[j] = temp;
    }
    for (var i=1; i<=p_num; i++) {
        var item = products[i];
        if( item.handle != p_current ){
          var url = item.url,
              title = item.title,
              img = item.image,
              price = item.price;
          	  product_html += '<div class="rp-item"><a href="' + url + '" class="rp-img"><img src="' + img + '" alt=""></a><div class="rp-product-info"><div class="h4 product-title"><a href="' + url + '">' + title + '</a></div><div class="h4 product-price">' + price + '</div></div></div>'; 
        }else{
        	p_num++;
        }
    }
    callback(product_html);
  });
}